import React from "react";
import { FontAwesomeIcon } from "@nef/core"


const DeleteIcon =(params:any) => {  
   const {onClick} = params;
   
  return <span style={{ color: "red"}}>&nbsp;<FontAwesomeIcon iconClassName="fa-trash" onClick={onClick} style={{ cursor: "pointer", color:"red"}}/></span>;
}
export default DeleteIcon;